module.exports = require("winston");